module.exports = __webpack_public_path__ + "img/image404.152e972a.png";